import * as Yup from 'yup';

import SelectCategory from './Components/SelectCategory';
import Brands from './Components/Brands';

const headers = [
  {
    id: "value",
    label: "Value",
    size: {xs: 12, lg: 6},
  }, 
  {
    id: "attribute",
    label: "Category",
    capitalize: true,
    size: {xs: 12, lg: 6},
  },
  {
    id: "brand_name",
    label: "Brand",
    size: {xs: 12, lg: 6},
  },
  {
    id: "tags",
    label: "Tags",
    size: {xs: 12, lg: 6},
  }
]

const filters = [
  
]

const fields = [
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "value",
    label: "Value",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "divider",
    header: "Advanced",
    name: "advanced",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "toggle",
    name: "scope",
    label: "Select Scope",
    options: [{value: "global", label: "Global"}, {value: "brand", label: "By Brand"}],
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Brands />,
    name: "brand",
    checkDisplayField: (values) => { return values?.scope === "brand"},
    size: {xs: 12, lg: 12},
  }
]

const values_config = [
  {
    fieldType: "Component",
    Component: <SelectCategory />,
    name: "category",
    size: {xs: 12, lg: 12},
  },
  ...fields
]

const initialValues = {
  brand_name: "",
  attribute: "color",
  value: "",
  scope: "global",
}

const values_initialValues = {
  brand_name: "",
  attribute: "",
  value: "",
  scope: "global",
}

const additionalState = {
  brands: []
}

const schema = Yup.object().shape({
  brand_name: Yup.string(),
  attribute: Yup.string().required('Required'),
  value: Yup.string().required('Required'),
  scope: Yup.string()
});

export { fields, schema, initialValues, headers, filters, additionalState, values_config, values_initialValues };
